// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetSelfStudySectionBySectionOrderHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import SelfStudySectionResponseDTO from '../models/SelfStudySectionResponseDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    academicYear: number;
    selfStudySectionOrder: number;
    selfStudyResponseId: string | null;
    allowNew: boolean;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            academicYear: 0,
            selfStudySectionOrder: 0,
            selfStudyResponseId: '00000000-0000-0000-0000-000000000000',
            allowNew: false,
        },
        initValues);
    },
    academicYear: 'academicYear',
    selfStudySectionOrder: 'selfStudySectionOrder',
    selfStudyResponseId: 'selfStudyResponseId',
    allowNew: 'allowNew',
}

interface Result extends ResultDTO {
    selfStudySection: SelfStudySectionResponseDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            selfStudySection: null,
        },
        initValues);
    },
    selfStudySection: 'selfStudySection',
}

export { Request, Result };